<template>
    <div class="main">
        <c-panel title="POSIÇÃO DE ESTOQUE" titleIcon="fas fa-warehouse">
            <el-alert v-if="avisoAlmoxarifado" type="warning" :closable="false" class="u-mb-15" show-icon
                :title="avisoAlmoxarifado"></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item label="Unidade">
                            <!-- A escola não escolhe unidade, e o select desabilitado
                                 mostraria o id: a lista de instituições da store só
                                 é preenchida para os perfis de rede (tipo > 3). -->
                            <el-select v-if="ehSmed" v-model="filtro.instituicao_id" filterable placeholder="Selecione"
                                style="width:100%;" @change="buscar">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                            <el-input v-else :value="nomeInstituicao" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Grupo de Material">
                            <el-select v-model="filtro.grupo_id" filterable clearable placeholder="Todos"
                                style="width:100%;" @change="buscar">
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Produto">
                            <el-input v-model="filtro.busca" clearable placeholder="Nome ou código"
                                @keyup.enter.native="buscar"></el-input>
                        </el-form-item>
                    </el-col>
                    
                </el-row>

                <el-row :gutter="10" class="u-mb-10">
                    <el-col :xs="24" :sm="7" :md="7">
                        <el-form-item label="Estoque mínimo">
                            <el-select v-model="filtro.abaixo_minimo" style="width:100%;" @change="buscar">
                                <el-option label="Todos os produtos" :value="false"></el-option>
                                <el-option label="Somente abaixo do mínimo" :value="true"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6" :md="6">
                        <el-form-item label="Status">
                            <el-select v-model="filtro.status" clearable placeholder="Todos" style="width:100%;" @change="buscar">
                                <el-option label="Normal" value="NORMAL"></el-option>
                                <el-option label="Zerado" value="ZERADO"></el-option>
                                <el-option label="Abaixo do mínimo" value="ABAIXO DO MINIMO"></el-option>
                                <el-option label="Acima do máximo" value="ACIMA DO MAXIMO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="7" :md="7">
                        <el-form-item label="Ordenar">
                            <el-select v-model="filtro.ordenar_por" style="width:100%;" @change="buscar">
                                <el-option label="Descrição" value="descricao"></el-option>
                                <el-option label="Código" value="codigo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4" class="u-text-right" style="padding-top: 30px;">
                        <el-button icon="el-icon-refresh" size="small" plain @click="limpar" class="u-mr-5">LIMPAR</el-button>
                        <el-button type="info" icon="el-icon-search" size="small" plain @click="buscar">BUSCAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table" v-loading="carregando">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:120px;">Código</th>
                            <th>Descrição</th>
                            <th style="width:70px;" class="u-text-center">UN.</th>
                            <th>Grupo</th>
                            <th style="width:110px;" class="u-text-center">Mínimo</th>
                            <th style="width:110px;" class="u-text-center">Máximo</th>
                            <th style="width:100px;" class="u-text-center">Disponível</th>
                            <th style="width:150px;" class="u-text-center">Status</th>
                            <th style="width:110px;" class="u-text-center" v-if="ehSmed">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="l in linhas" :key="l.id">
                            <td>{{ l.codigo }}</td>
                            <td>{{ l.nome }}</td>
                            <td class="u-text-center">{{ l.unidade_medida }}</td>
                            <td>{{ l.grupo_nome || '—' }}</td>
                            <td class="u-text-center">{{ l.estoque_minimo > 0 ? formataQtd(l.estoque_minimo) : '—' }}</td>
                            <td class="u-text-center">{{ l.estoque_maximo > 0 ? formataQtd(l.estoque_maximo) : '—' }}</td>
                            <td class="u-text-center"><strong>{{ formataQtd(l.saldo) }}</strong></td>
                            <td class="u-text-center">
                                <span :class="'st-' + classeStatus(l.status)">{{ l.status }}</span>
                            </td>
                            <td class="u-text-center" v-if="ehSmed">
                                <el-button size="mini" plain icon="el-icon-edit" title="Definir mínimo e máximo"
                                    @click="abrirLimites(l)" class="u-mr-5"></el-button>
                                <el-button size="mini" plain type="warning" icon="el-icon-sort" title="Ajustar saldo"
                                    @click="abrirAjuste(l)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!linhas.length">
                            <td :colspan="ehSmed ? 9 : 8" class="u-text-center" style="color:#909399; padding:12px;">
                                {{ filtro.instituicao_id ? 'Nenhum produto encontrado.' : 'Selecione a unidade.' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </c-panel>

        <!-- ==================== LIMITES ==================== -->
        <el-dialog title="Estoque mínimo e máximo" :visible.sync="modal" width="480px" :close-on-click-modal="false">
            <div v-if="atual">
                <p class="u-mb-15"><strong>{{ atual.nome }}</strong> ({{ atual.unidade_medida }})</p>

                <el-form label-position="top" @submit.native.prevent>
                    <el-row :gutter="10">
                        <el-col :xs="12">
                            <el-form-item label="Estoque mínimo">
                                <el-input v-model="limites.estoque_minimo" placeholder="0"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12">
                            <el-form-item label="Estoque máximo">
                                <el-input v-model="limites.estoque_maximo" placeholder="0"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <p style="color:#909399; font-size:12px;">
                    Zero significa sem limite. Os valores valem só para esta unidade.
                </p>
            </div>

            <span slot="footer">
                <el-button @click="modal = false">CANCELAR</el-button>
                <el-button type="primary" icon="el-icon-check" @click="salvarLimites">SALVAR</el-button>
            </span>
        </el-dialog>

        <!-- ==================== AJUSTE DE SALDO ==================== -->
        <el-dialog title="Ajuste de estoque" :visible.sync="modalAjuste" width="70%" :close-on-click-modal="false">
            <div v-if="atual">
                <el-alert type="warning" :closable="false" class="u-mb-15 u-mt-10" show-icon
                    title="Correção direta de saldo, sem entrada, saída ou transferência. Use apenas para acertar divergência de inventário."></el-alert>

                <p class="u-mb-15"><strong>{{ atual.nome }}</strong> ({{ atual.unidade_medida }})</p>

                <el-form label-position="top" @submit.native.prevent>
                    <el-row :gutter="10">
                        <el-col :xs="8">
                            <el-form-item label="Saldo atual">
                                <el-input :value="formataQtd(atual.saldo)" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="8">
                            <el-form-item label="Novo saldo">
                                <el-input v-model="ajuste.saldo_novo" placeholder="0"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="8">
                            <el-form-item label="Diferença">
                                <el-input :value="diferencaTexto" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="16">
                            <el-form-item label="Motivo do ajuste">
                                <el-input v-model="ajuste.observacao" maxlength="255"
                                    placeholder="Ex.: acerto de inventário"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="8">
                            <el-form-item label="Data">
                                <el-date-picker v-model="ajuste.data_movimento" type="date" format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <span slot="footer">
                <el-button @click="modalAjuste = false">CANCELAR</el-button>
                <el-button type="primary" icon="el-icon-check" @click="salvarAjuste">AJUSTAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
/**
 * Posição de estoque de uma unidade: o que existe, os limites parametrizados e
 * como cada produto está em relação a eles.
 *
 * Lista todos os produtos ativos, inclusive os que nunca se movimentaram — é
 * justamente o produto zerado que o almoxarifado precisa enxergar.
 */
export default {
    data: () => ({
        carregando: false,
        grupos: [],
        linhas: [],
        avisoAlmoxarifado: '',
        modal: false,
        modalAjuste: false,
        atual: null,
        limites: { estoque_minimo: '', estoque_maximo: '' },
        ajuste: { saldo_novo: '', observacao: '', data_movimento: '' },
        filtro: { instituicao_id: '', grupo_id: '', busca: '', status: '', ordenar_por: 'descricao', abaixo_minimo: false }
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        nomeInstituicao () { return this.$store.state.config.instituicao.nome || '-' },
        /** A store guarda as instituições como objeto; comparar exige normalizar. */
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        },
        /** Prévia do que vai acontecer, para conferir antes de gravar. */
        diferencaTexto () {
            if (!this.atual || this.ajuste.saldo_novo === '') return ''

            const novo = Number(String(this.ajuste.saldo_novo).replace(',', '.'))
            if (isNaN(novo)) return ''

            const d = Math.round((novo - Number(this.atual.saldo)) * 1000) / 1000

            return d > 0 ? '+' + this.formataQtd(d) : this.formataQtd(d)
        }
    },
    mounted () {
        this.carregarGrupos()

        if (!this.ehSmed) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
            this.buscar()
            return
        }

        // Para a SMED a tela abre no almoxarifado: é a unidade que ela consulta
        // no dia a dia. As outras continuam a um clique no select.
        this.carregarAlmoxarifado()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },
        aviso (msg) { window.eventBus.$emit('alert', { msg, type: 'warning' }) },
        formataQtd (v) { const n = Number(v) || 0; return n % 1 === 0 ? String(n) : n.toFixed(3) },
        classeStatus (s) {
            return { 'ZERADO': 'zerado', 'ABAIXO DO MINIMO': 'baixo', 'ACIMA DO MAXIMO': 'alto' }[s] || 'normal'
        },

        /**
         * A tela abre no almoxarifado. Falhar aqui em silêncio deixaria o usuário
         * diante de um select vazio sem saber por quê — daí o aviso.
         */
        carregarAlmoxarifado () {
            this.$axios.get(`${this.baseUrl()}/api/almox-requisicao/almoxarifado`, this.auth())
                .then(r => {
                    if (!r.data || !r.data.id) {
                        this.avisoAlmoxarifado = 'Nenhuma instituição está marcada como almoxarifado. '
                            + 'Marque uma no cadastro de instituição para a tela abrir nela automaticamente.'
                        return
                    }

                    // A instituição precisa estar na lista do select, senão o campo
                    // fica em branco mesmo com o id preenchido.
                    if (!this.listaInstituicoes.some(i => Number(i.id) === Number(r.data.id))) {
                        this.avisoAlmoxarifado = `O almoxarifado (${r.data.nome}) não está entre as instituições `
                            + 'que você pode consultar. Escolha a unidade manualmente.'
                        return
                    }

                    this.filtro.instituicao_id = r.data.id
                    this.buscar()
                })
                .catch(e => this.$store.commit('throwException', e))
        },
        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll?situacao=true`, this.auth())
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        buscar () {
            if (!this.filtro.instituicao_id) { this.linhas = []; return }

            this.carregando = true

            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/posicao`, this.filtro, this.auth())
                .then(r => {
                    if (r.data && r.data.erro) { this.aviso(r.data.erro); this.linhas = []; this.carregando = false; return }

                    this.linhas = Array.isArray(r.data) ? r.data : []
                    this.carregando = false
                })
                .catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        limpar () {
            this.filtro.grupo_id = ''
            this.filtro.busca = ''
            this.filtro.status = ''
            this.filtro.abaixo_minimo = false
            this.buscar()
        },

        abrirAjuste (l) {
            this.atual = l
            this.ajuste = {
                saldo_novo: String(l.saldo),
                observacao: '',
                data_movimento: this.$moment().format('YYYY-MM-DD')
            }
            this.modalAjuste = true
        },
        salvarAjuste () {
            const novo = Number(String(this.ajuste.saldo_novo).replace(',', '.'))

            if (isNaN(novo) || novo < 0) { this.aviso('Informe um saldo válido.'); return }
            if (!String(this.ajuste.observacao || '').trim()) { this.aviso('Informe o motivo do ajuste.'); return }

            const de = this.formataQtd(this.atual.saldo)
            const para = this.formataQtd(novo)

            this.$msgbox.confirm(
                `Alterar o saldo de ${this.atual.nome} de ${de} para ${para}?`, 'Confirmar ajuste',
                { confirmButtonText: 'Sim, ajustar', cancelButtonText: 'Cancelar', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)

                this.$axios.post(`${this.baseUrl()}/api/almox-estoque/ajuste`, {
                    produto_id: this.atual.id,
                    instituicao_id: this.filtro.instituicao_id,
                    saldo_novo: novo,
                    observacao: this.ajuste.observacao,
                    data_movimento: this.ajuste.data_movimento
                }, this.auth())
                    .then(r => {
                        window.eventBus.$emit('loading', false)
                        if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                        window.eventBus.$emit('alert', {
                            msg: `Saldo ajustado de ${this.formataQtd(r.data.saldo_anterior)} para ${this.formataQtd(r.data.saldo_atual)}.`,
                            type: 'success'
                        })
                        this.modalAjuste = false
                        this.buscar()
                    })
                    .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        abrirLimites (l) {
            this.atual = l
            this.limites = {
                estoque_minimo: l.estoque_minimo > 0 ? String(l.estoque_minimo) : '',
                estoque_maximo: l.estoque_maximo > 0 ? String(l.estoque_maximo) : ''
            }
            this.modal = true
        },
        salvarLimites () {
            const num = v => Number(String(v || '0').replace(',', '.')) || 0

            const payload = {
                produto_id: this.atual.id,
                instituicao_id: this.filtro.instituicao_id,
                estoque_minimo: num(this.limites.estoque_minimo),
                estoque_maximo: num(this.limites.estoque_maximo)
            }

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/limites`, payload, this.auth())
                .then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                    window.eventBus.$emit('alert', { msg: 'Limites atualizados.', type: 'success' })
                    this.modal = false
                    this.buscar()
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>

<style scoped>
.resumo { color: #909399; font-size: 12px; margin-right: 10px; }
.st-zerado  { color: #909399; font-weight: bold; }
.st-baixo   { color: #f56c6c; font-weight: bold; }
.st-alto    { color: #e6a23c; font-weight: bold; }
.st-normal  { color: #67c23a; font-weight: bold; }
</style>
